import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Image from '../global/Image';

export default class PageTextCarousel extends Component {
    
    constructor(){
		super()
		this.state = {
			open:false,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    	setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    } else {
		    this.setState({ open : true });
		    setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    }
    }
    
	render () {
		
		let block 	= this.props.block;
		
		if (block) {
						
		    return (
		        
		        <div className="c-projects">
					    	
		    		<div className="c-projects__inner">
		    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    			
			    				<header className="c-projects__header">
			    				
			    					<h1 className="c-heading c-heading--reverse">
										<span className="c-heading__line">
											<span className="c-heading__line__inner" dangerouslySetInnerHTML={{__html:'Projects'}}></span>
										</span>
									</h1>
									
									
								</header>
								
								
								
								<div className="c-projects__line c-load-fade"></div>
								
								<div className={'c-load-fade c-projects__filters c-projects__filter--' + this.state.open}>
									<h4 className="c-projects__filters__heading" onClick={(e) => (e.preventDefault(), this.handleToggle(e.currentTarget))}>Filter</h4>
									<div className="c-projects__filters__wrap">
										<a href="#" className="c-projects__filters__trigger c-projects__filters__trigger--desktop" onClick={(e) => (e.preventDefault(), this.handleToggle(e.currentTarget))}>Project type</a>
										<a href="#" className="c-projects__filters__trigger c-projects__filters__trigger--mobile" onClick={(e) => (e.preventDefault(), this.handleToggle(e.currentTarget))} dangerouslySetInnerHTML={{__html: block.filtertitle}}></a>
										<div className={'c-projects__filters__accordion'}>
											<ul className="c-projects__filters__accordion-inner">
												{block.term.map((term,i) =>
													{
														if (block.slug == term.slug) {
															return (
																<li className="c-projects__filters__item">
																	<Link to={{ pathname: '/type/' + term.slug }} className="c-projects__filters__link state-active" dangerouslySetInnerHTML={{__html:term.title}}></Link>
	
																</li>
															)
														} else {
															return (
																<li className="c-projects__filters__item">
																	<Link to={{ pathname: '/type/' + term.slug }} className="c-projects__filters__link" dangerouslySetInnerHTML={{__html:term.title}}></Link>
	
																</li>
															)
														}
													}
												)}
												{block.slug == 'view-all' &&
													<li className="c-projects__filters__item">
														<Link to={{ pathname: '/projects/' }} className="c-projects__filters__link state-active">View all</Link>

													</li>
												}
												{block.slug != 'view-all' &&
													<li className="c-projects__filters__item">
														<Link to={{ pathname: '/projects/' }} className="c-projects__filters__link">View all</Link>

													</li>
												}
											</ul>
										</div>
									</div>
								</div>
								
								<div className="c-projects__thumbs">
									
									{block.project.map((project,i) =>
										{
											if (project.active == true && project.link_type === 'standard') {
												return (
													<div className="c-projects__thumbs__thumb" key={i}>
														<Link to={{ pathname: '/project/' + project.slug }} className="c-projects__thumbs__thumb__block" data-link-type="standard">
															<div className="c-projects__thumbs__thumb__image">
																<Image src={project.src} srcset={project.srcset}></Image>
																<div className="c-projects__thumbs__thumb__overlay">
																	{project.type == 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
																	}
																	{project.type != 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
																	}
																	<h4 dangerouslySetInnerHTML={{__html:project.status}}></h4>
																</div>
															</div>
															{project.type == 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading" dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
															}
															{project.type != 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading c-load-fade" dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
															}
															<p className="c-projects__thumbs__thumb__text c-load-fade" dangerouslySetInnerHTML={{__html:'Type: ' + project.type }}></p>
														</Link>
													</div>
												)
											} else if (project.active == true && project.link_type === 'custom' && project.slug.indexOf('http') === -1) {
												return (
													<div className="c-projects__thumbs__thumb" key={i}>
														<Link to={{ pathname: project.slug }} className="c-projects__thumbs__thumb__block" data-link-type="custom-internal">
															<div className="c-projects__thumbs__thumb__image">
																<Image src={project.src} srcset={project.srcset}></Image>
																<div className="c-projects__thumbs__thumb__overlay">
																	{project.type == 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
																	}
																	{project.type != 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
																	}
																	{project.status == 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:'Coming Soon'}}></h4>
																	}
																	{project.status != 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:project.status}}></h4>
																	}
																</div>
															</div>
															{project.type == 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading" dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
															}
															{project.type != 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading c-load-fade" dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
															}
															<p className="c-projects__thumbs__thumb__text c-load-fade" dangerouslySetInnerHTML={{__html:'Type: ' + project.type }}></p>
														</Link>
													</div>
												)
											} else if (project.active == true && project.link_type === 'custom' && project.slug.indexOf('http') !== -1) {
												return (
													<div className="c-projects__thumbs__thumb" key={i}>
														<a href={project.slug} target="_blank" className="c-projects__thumbs__thumb__block" data-link-type="custom-external">
															<div className="c-projects__thumbs__thumb__image">
																<Image src={project.src} srcset={project.srcset}></Image>
																<div className="c-projects__thumbs__thumb__overlay">
																	{project.type == 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
																	}
																	{project.type != 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
																	}
																	{project.status == 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:'Coming Soon'}}></h4>
																	}
																	{project.status != 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:project.status}}></h4>
																	}
																</div>
															</div>
															{project.type == 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading" dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
															}
															{project.type != 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading c-load-fade" dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
															}
															<p className="c-projects__thumbs__thumb__text c-load-fade" dangerouslySetInnerHTML={{__html:'Type: ' + project.type }}></p>
														</a>
													</div>
												)
											} else {
												return (
													<div className="c-projects__thumbs__thumb" key={i}>
														<div className="c-projects__thumbs__thumb__block">
															<div className="c-projects__thumbs__thumb__image">
																<Image src={project.src} srcset={project.srcset}></Image>
																<div className="c-projects__thumbs__thumb__overlay">
																	{project.type == 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
																	}
																	{project.type != 'House & Land' &&
																		<h3 dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
																	}
																	{project.status == 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:'Coming Soon'}}></h4>
																	}
																	{project.status != 'Under Construction' &&
																		<h4 dangerouslySetInnerHTML={{__html:project.status}}></h4>
																	}
																</div>
															</div>
															{project.type == 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading" dangerouslySetInnerHTML={{__html:'H&L' + ' / ' + project.title}}></h3>
															}
															{project.type != 'House & Land' &&
																<h3 className="c-projects__thumbs__thumb__heading c-load-fade" dangerouslySetInnerHTML={{__html:project.title + ' / ' + project.suburb}}></h3>
															}
														</div>
													</div>
												)
											}
										}
									)}
									
								</div>
								
							</div>
				    	
				    	</div>
				    	
				    </div>
				    
				</div>
    	
			        	
			)
			
		} else {
			
			return null;
		
		}
	}
}
